<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="10"
          class="d-flex flex-wrap"
        >
          <v-row v-if="exibirChips">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-tooltip
                v-for="chip in appliedFilters"
                :key="chip.label"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    class="ma-1"
                    color="#e8f1ff"
                    text-color="#2863af"
                    small
                    :close="!['dataInicio', 'dataFim', 'dataInicio2', 'dataFim2'].includes(chip.key)"
                    v-on="on"
                    @click:close="removeFilter(chip.key)"
                  >
                    {{ chip.label }}
                  </v-chip>
                </template>
                <span>{{ getTooltipValue(chip) }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="d-flex justify-end"
        >
          <v-btn
            v-if="exibirChips"
            text
            :color="corPrimaria"
            @click="updateDate()"
          >
            <v-icon>
              mdi-reload-alert
            </v-icon>
            Consultar
          </v-btn>
          <v-btn
            text
            style="color: #2863af;"
            @click="toggleDrawer"
          >
            <v-icon>{{ drawer ? 'mdi-filter-minus' : 'mdi-filter-plus' }}</v-icon>
            {{ drawer ? 'Fechar filtros' : 'Filtros' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      width="700"
      fixed
      attach="body"
      class="pa-4 elevation-10 drawerFiltros"
      style="z-index: 3000;"
    >
      <v-container>
        <v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                text
                style="color: #2863af;"
                @click="toggleDrawer"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <transition name="filters">
              <v-row v-if="filtroCompleto">
                <br>
                <br>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <h3
                      v-if="textoFiltro"
                      class="text-center"
                    >
                      Filtros 1
                    </h3>
                    <h3
                      v-else
                      class="text-center"
                    >
                      Período 1
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-if="enableDatas"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-menu
                      v-if="primeiro"
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedPrimeiroDia"
                          label="Data Inical"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="primeiroDia"
                        no-title
                        @input="menu1 = false"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          :color="corPrimaria"
                          @click="definirHoje('primeiroDia')"
                        >
                          Hoje
                        </v-btn>
                        <v-btn
                          text
                          :color="corPrimaria"
                          @click="menu1 = false"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    v-if="enableDatas"
                    id="menu3"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-menu
                      v-if="ultimo"
                      v-model="menu3"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateFormatted"
                          label="Data Final"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="date"
                        no-title
                        @input="menu3 = false"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          :color="corPrimaria"
                          @click="definirHoje('dataFinal')"
                        >
                          Hoje
                        </v-btn>
                        <v-btn
                          text
                          :color="corPrimaria"
                          @click="menu3 = false"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    id="selectEmpresa"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-if="empresas"
                      v-model="select"
                      :items="empresa"
                      item-value="id"
                      item-text="nomeExibicao"
                      label="Empresas"
                      multiple
                      return-object
                      @change="filtrarEmpresa()"
                    />
                  </v-col>
                  <!-- Aqui filtro cidades -->
                  <v-col
                    v-if="cidades"
                    id="selectCidades"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="cidadeSelect"
                      :items="filterCidades.length > 0 ? filterCidades : cidade"
                      item-value="id"
                      item-text="cidade"
                      label="Cidades"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.cidade }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.cidade }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ cidadeSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione uma cidade
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroCidades"
                              v-model="filtroCidades"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Cidades"
                              @change="filterCidadesToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleCidades"
                        >
                          <v-list-item-action>
                            <v-icon :color="cidadeSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconCidades }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro clientes -->
                  <v-col
                    v-if="clientes"
                    id="selectCidades"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="clienteSelect"
                      item-value="id"
                      :items="filterClientes.length > 0 ? filterClientes : (clienteFilter.length > 0 ? clienteFilter : cliente)"
                      :item-text="formatCliente"
                      label="Clientes"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ clienteSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione um cliente
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroClientes"
                              v-model="filtroClientes"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Clientes"
                              @change="filterClientesToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleClientes"
                        >
                          <v-list-item-action>
                            <v-icon :color="clienteSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconClientes }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro area -->
                  <v-col
                    v-if="areas"
                    id="selectAreas"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="areaSelect"
                      :items="filterAreas.length > 0 ? filterAreas : (areaFilter.length > 0 ? areaFilter : area)"
                      item-value="idExibicao"
                      :item-text="formatArea"
                      label="Áreas"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ areaSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        selecione uma área
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroAreas"
                              v-model="filtroAreas"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Redes"
                              @change="filterAreasToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleAreas"
                        >
                          <v-list-item-action>
                            <v-icon :color="areaSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconAreas }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todas
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro supervisor -->
                  <v-col
                    v-if="supervisores"
                    id="selectVendedores"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="supervisorSelect"
                      :items="filterSupervisor.length > 0 ? filterSupervisor : (supervisorFilter.length > 0 ? supervisorFilter : supervisor)"
                      item-value="idExibicao"
                      :item-text="formatSupervisor"
                      label="Supervisores"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ supervisorSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione um Supervisor
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroSupervisor"
                              v-model="filtroSupervisor"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Vendedores"
                              @change="filterSupervisoresToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleSupervisores"
                        >
                          <v-list-item-action>
                            <v-icon :color="supervisorSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconSupervisores }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro vendedor -->
                  <v-col
                    v-if="vendedores"
                    id="selectVendedores"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="vendedorSelect"
                      :items="filterVendedores.length > 0 ? filterVendedores : (vendedorFilter.length > 0 ? vendedorFilter : vendedor)"
                      item-value="idExibicao"
                      :item-text="formatVendedor"
                      label="Vendedores"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ vendedorSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione um vendedor
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroVendedores"
                              v-model="filtroVendedores"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Vendedores"
                              @change="filterVendedoresToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleVendedores"
                        >
                          <v-list-item-action>
                            <v-icon :color="vendedorSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconVendedores }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro segmento(rede) -->
                  <v-col
                    v-if="redes"
                    id="selectRedes"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="redeSelect"
                      :items="filterRedes.length > 0 ? filterRedes : (redeFilter.length > 0 ? redeFilter : rede)"
                      item-value="idExibicao"
                      :item-text="formatRede"
                      label="Redes"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ redeSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        selecione uma rede
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroRedes"
                              v-model="filtroRedes"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Redes"
                              @change="filterRedesToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleRedes"
                        >
                          <v-list-item-action>
                            <v-icon :color="redeSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconRedes }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro produto -->
                  <v-col
                    v-if="produtos"
                    id="selectProdutos"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="produtoSelect"
                      :items="filterProdutos.length > 0 ? filterProdutos : (produtoFilter.length > 0 ? produtoFilter : produto)"
                      item-value="id"
                      :item-text="formatProduto"
                      label="Produtos"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ produtoSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione um produto
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroProdutos"
                              v-model="filtroProdutos"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Produtos"
                              @change="filterProdutosToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleProdutos"
                        >
                          <v-list-item-action>
                            <v-icon :color="produtoSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconProdutos }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todos
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro linha produto -->
                  <v-col
                    v-if="linhas"
                    id="selectLinhas"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="linhaSelect"
                      :items="filterLinhas.length > 0 ? filterLinhas : (linhaFilter.length > 0 ? linhaFilter : linhasProducao)"
                      item-value="id"
                      :item-text="formatLinha"
                      label="Linhas"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ linhaSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione uma linha
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroProdutos"
                              v-model="filtroLinhas"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Linhas"
                              @change="filterLinhasToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleLinhas"
                        >
                          <v-list-item-action>
                            <v-icon :color="linhaSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconLinhas }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todas
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <!-- Aqui filtro caixas -->
                  <v-col
                    v-if="caixas"
                    id="selectLinhas"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="caixaSelect"
                      :items="filterCaixas.length > 0 ? filterCaixas : caixa"
                      item-value="id"
                      item-text="caixa"
                      label="Caixas"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.caixa }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.caixa }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ caixaSelect.length - 2 }} outros)
                        </span>
                      </template>
                      <template v-slot>
                        Selecione uma caixa
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-action>
                            <input
                              id="filtroCaixas"
                              v-model="filtroCaixas"
                              prepend-inner-icon="mdi-account-search"
                              placeholder="Filtrar Caixas"
                              @change="filterCaixasToggle"
                            >
                          </v-list-item-action>
                          <v-divider
                            slot="prepend-item"
                            class="mt-2"
                          /><br>
                        </v-list-item>
                        <v-list-item
                          slot="prepend-item"
                          ripple
                          @click="toggleCaixas"
                        >
                          <v-list-item-action>
                            <v-icon :color="caixaSelect.length > 0 ? 'indigo darken-4' : ''">
                              {{ iconCaixas }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-title id="idSelecTotos">
                            Selecionar todas
                          </v-list-item-title>
                        </v-list-item>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        />
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    v-if="segmentos && segmento.length > 0"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                  >
                    <v-select
                      v-model="selectSegmento"
                      :items="filterSegmento.length > 0 ? filterSegmento : segmento"
                      item-value="idExibicao"
                      :item-text="formatSegmento"
                      label="Segmento Cliente"
                      multiple
                      return-object
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                          <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <v-chip v-if="index === 1">
                          <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                        </v-chip>
                        <span
                          v-if="index === 2"
                          class="grey--text text-caption"
                        >
                          (+{{ selectSegmento.length - 2 }} outros)
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <h3
                      v-if="textoFiltro"
                      class="text-center"
                    >
                      Filtros 2
                    </h3>
                    <h3
                      v-else
                      class="text-center"
                    >
                      Período 2
                    </h3>
                    <v-row>
                      <v-col
                        v-if="enableDatas1"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-menu
                          v-if="primeiro"
                          ref="menu2"
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="computedPrimeiroDia2"
                              label="Data Inical"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              readonly
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="primeiroDia2"
                            no-title
                            @input="menu2 = false"
                          >
                            <v-spacer />
                            <v-btn
                              text
                              :color="corPrimaria"
                              @click="definirHoje('primeiroDia2')"
                            >
                              Hoje
                            </v-btn>
                            <v-btn
                              text
                              :color="corPrimaria"
                              @click="menu2 = false"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        v-if="enableDatas1"
                        id="menu2"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-menu
                          v-if="ultimo"
                          v-model="menu4"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="computedDateFormatted1"
                              label="Data Final"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="date2"
                            no-title
                            @input="menu4 = false"
                          >
                            <v-spacer />
                            <v-btn
                              text
                              :color="corPrimaria"
                              @click="definirHoje('dataFinal2')"
                            >
                              Hoje
                            </v-btn>
                            <v-btn
                              text
                              :color="corPrimaria"
                              @click="menu4 = false"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        v-if="empresas1"
                        id="selectEmpresa"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="select1"
                          :items="empresa"
                          item-value="id"
                          item-text="nomeExibicao"
                          label="Empresas"
                          multiple
                          return-object
                          @change="filtrarEmpresa1()"
                        />
                      </v-col>
                      <!-- Aqui filtro cidades -->
                      <v-col
                        v-if="cidades1"
                        id="selectCidades"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="cidadeSelect1"
                          :items="filterCidades1.length > 0 ? filterCidades1 : cidade"
                          item-value="id"
                          item-text="cidade"
                          label="Cidades"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.cidade }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.cidade }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ cidadeSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione uma cidade
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroCidades"
                                  v-model="filtroCidades1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Cidades"
                                  @change="filterCidadesToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleCidades1"
                            >
                              <v-list-item-action>
                                <v-icon :color="cidadeSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconCidades1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro clientes -->
                      <v-col
                        v-if="clientes1"
                        id="selectCidades"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="clienteSelect1"
                          :items="filterClientes1.length > 0 ? filterClientes1 : (clienteFilter1.length > 0 ? clienteFilter1 : cliente)"
                          item-value="id"
                          :item-text="formatCliente"
                          label="Clientes"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ clienteSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione um cliente
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroClientes"
                                  v-model="filtroClientes1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Clientes"
                                  @change="filterClientesToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleClientes1"
                            >
                              <v-list-item-action>
                                <v-icon :color="clienteSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconClientes1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro area -->
                      <v-col
                        v-if="areas1"
                        id="selectAreas"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="areaSelect1"
                          :items="filterAreas1.length > 0 ? filterAreas1 : (areaFilter1.length > 0 ? areaFilter1 : area)"
                          item-value="idExibicao"
                          :item-text="formatArea"
                          label="Áreas"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ areaSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            selecione uma área
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroAreas"
                                  v-model="filtroAreas1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Redes"
                                  @change="filterAreasToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleAreas1"
                            >
                              <v-list-item-action>
                                <v-icon :color="areaSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconAreas1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todas
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro supervisor -->
                      <v-col
                        v-if="supervisores1"
                        id="selectVendedores"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="supervisorSelect1"
                          :items="filterSupervisor1.length > 0 ? filterSupervisor1 : (supervisorFilter1.length > 0 ? supervisorFilter1 : supervisor)"
                          item-value="idExibicao"
                          :item-text="formatSupervisor"
                          label="Supervisores"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ supervisorSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione um Supervisor
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroSupervisor"
                                  v-model="filtroSupervisor1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Vendedores"
                                  @change="filterSupervisoresToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleSupervisores1"
                            >
                              <v-list-item-action>
                                <v-icon :color="supervisorSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconSupervisores1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro vendedor -->
                      <v-col
                        v-if="vendedores1"
                        id="selectVendedores"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="vendedorSelect1"
                          :items="filterVendedores1.length > 0 ? filterVendedores1 : (vendedorFilter1.length > 0 ? vendedorFilter1 : vendedor)"
                          item-value="idExibicao"
                          :item-text="formatVendedor"
                          label="Vendedores"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ vendedorSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione um vendedor
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroVendedores"
                                  v-model="filtroVendedores1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Vendedores"
                                  @change="filterVendedoresToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleVendedores1"
                            >
                              <v-list-item-action>
                                <v-icon :color="vendedorSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconVendedores1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro segmento(rede) -->
                      <v-col
                        v-if="redes1"
                        id="selectRedes"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="redeSelect1"
                          :items="filterRedes1.length > 0 ? filterRedes1 : (redeFilter1.length > 0 ? redeFilter1 : rede)"
                          item-value="idExibicao"
                          :item-text="formatRede"
                          label="Redes"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ redeSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            selecione uma rede
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroRedes"
                                  v-model="filtroRedes1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Redes"
                                  @change="filterRedesToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleRedes1"
                            >
                              <v-list-item-action>
                                <v-icon :color="redeSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconRedes1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro produto -->
                      <v-col
                        v-if="produtos1"
                        id="selectProdutos"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="produtoSelect1"
                          :items="filterProdutos1.length > 0 ? filterProdutos1 : (produtoFilter1.length > 0 ? produtoFilter1 : produto)"
                          item-value="id"
                          :item-text="formatProduto"
                          label="Produtos"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ produtoSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione um produto
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroProdutos"
                                  v-model="filtroProdutos1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Produtos"
                                  @change="filterProdutosToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleProdutos1"
                            >
                              <v-list-item-action>
                                <v-icon :color="produtoSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconProdutos1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todos
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro linha produto -->
                      <v-col
                        v-if="linhas1"
                        id="selectLinhas"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="linhaSelect1"
                          :items="filterLinhas1.length > 0 ? filterLinhas1 : (linhaFilter1.length > 0 ? linhaFilter1 : linhasProducao)"
                          item-value="id"
                          :item-text="formatLinha"
                          label="Linhas"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ linhaSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione uma linha
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroProdutos"
                                  v-model="filtroLinhas1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Linhas"
                                  @change="filterLinhasToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleLinhas1"
                            >
                              <v-list-item-action>
                                <v-icon :color="linhaSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconLinhas1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todas
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro caixas -->
                      <v-col
                        v-if="caixas1"
                        id="selectLinhas"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="caixaSelect1"
                          :items="filterCaixas1.length > 0 ? filterCaixas1 : caixa"
                          item-value="id"
                          item-text="caixa"
                          label="Caixas"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.caixa }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.caixa }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ caixaSelect1.length - 2 }} outros)
                            </span>
                          </template>
                          <template v-slot>
                            Selecione uma caixa
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item>
                              <v-list-item-action>
                                <input
                                  id="filtroCaixas"
                                  v-model="filtroCaixas1"
                                  prepend-inner-icon="mdi-account-search"
                                  placeholder="Filtrar Caixas"
                                  @change="filterCaixasToggle1"
                                >
                              </v-list-item-action>
                              <v-divider
                                slot="prepend-item"
                                class="mt-2"
                              /><br>
                            </v-list-item>
                            <v-list-item
                              slot="prepend-item"
                              ripple
                              @click="toggleCaixas1"
                            >
                              <v-list-item-action>
                                <v-icon :color="caixaSelect1.length > 0 ? 'indigo darken-4' : ''">
                                  {{ iconCaixas1 }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-title id="idSelecTotos">
                                Selecionar todas
                              </v-list-item-title>
                            </v-list-item>
                            <v-divider
                              slot="prepend-item"
                              class="mt-2"
                            />
                          </template>
                        </v-select>
                      </v-col>
                      <!-- Aqui filtro segmento -->
                      <v-col
                        v-if="segmentos1 && segmento.length > 0"
                        id="selectEmpresa"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-select
                          v-model="selectSegmento1"
                          :items="filterSegmento1.length > 0 ? filterSegmento1 : segmento"
                          item-value="idExibicao"
                          :item-text="formatSegmento"
                          label="Segmento Cliente"
                          multiple
                          return-object
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <v-chip v-if="index === 1">
                              <span>{{ item.segmento }} - {{ item.nomeBd }}, </span>
                            </v-chip>
                            <span
                              v-if="index === 2"
                              class="grey--text text-caption"
                            >
                              (+{{ selectSegmento1.length - 2 }} outros)
                            </span>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <v-btn
                          id="btnRefazer"
                          class="col-12 lg-12 text-h4"
                          small
                          :color="corPrimaria"
                          dark
                          @click="updateDate()"
                        >
                          <v-icon>
                            mdi-reload-alert
                          </v-icon>
                          Consutlar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-row>
              <v-row v-else>
                <v-col
                  v-if="enableDatas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-if="primeiro"
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedPrimeiroDia"
                        label="Data Inical"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="primeiroDia"
                      no-title
                      @input="menu1 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('primeiroDia')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu1 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="enableDatas"
                  id="menu3"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-menu
                    v-if="ultimo"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Data Final"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu3 = false"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="definirHoje('dataFinal')"
                      >
                        Hoje
                      </v-btn>
                      <v-btn
                        text
                        :color="corPrimaria"
                        @click="menu3 = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  v-if="empresas"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="select"
                    :items="empresa"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Empresas"
                    multiple
                    return-object
                    @change="filtrarEmpresa()"
                  />
                </v-col>
                <!-- Aqui filtro cidades -->
                <v-col
                  v-if="cidades"
                  id="selectCidades"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="cidadeSelect"
                    :items="filterCidades.length > 0 ? filterCidades : cidade"
                    item-value="id"
                    item-text="cidade"
                    label="Cidades"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.cidade }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.cidade }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ cidadeSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma cidade
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroCidades"
                            v-model="filtroCidades"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Cidades"
                            @change="filterCidadesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleCidades"
                      >
                        <v-list-item-action>
                          <v-icon :color="cidadeSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconCidades }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro clientes -->
                <v-col
                  v-if="clientes"
                  id="selectCidades"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="clienteSelect"
                    :items="filterClientes.length > 0 ? filterClientes : (clienteFilter.length > 0 ? clienteFilter : cliente)"
                    item-value="id"
                    :item-text="formatCliente"
                    label="Clientes"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.cliente }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ clienteSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um cliente
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroClientes"
                            v-model="filtroClientes"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Clientes"
                            @change="filterClientesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleClientes"
                      >
                        <v-list-item-action>
                          <v-icon :color="clienteSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconClientes }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro area -->
                <v-col
                  v-if="areas"
                  id="selectAreas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="areaSelect"
                    :items="filterAreas.length > 0 ? filterAreas : (areaFilter.length > 0 ? areaFilter : area)"
                    item-value="idExibicao"
                    :item-text="formatArea"
                    label="Áreas"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.area }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ areaSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma área
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroAreas"
                            v-model="filtroAreas"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Redes"
                            @change="filterAreasToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleAreas"
                      >
                        <v-list-item-action>
                          <v-icon :color="areaSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconAreas }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro supervisor -->
                <v-col
                  v-if="supervisores"
                  id="selectVendedores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="supervisorSelect"
                    :items="filterSupervisor.length > 0 ? filterSupervisor : (supervisorFilter.length > 0 ? supervisorFilter : supervisor)"
                    item-value="idExibicao"
                    :item-text="formatSupervisor"
                    label="Supervisores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.supervisor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ supervisorSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um Supervisor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroSupervisor"
                            v-model="filtroSupervisor"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Vendedores"
                            @change="filterSupervisoresToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleSupervisores"
                      >
                        <v-list-item-action>
                          <v-icon :color="supervisorSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconSupervisores }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro vendedor -->
                <v-col
                  v-if="vendedores"
                  id="selectVendedores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="vendedorSelect"
                    :items="filterVendedores.length > 0 ? filterVendedores : (vendedorFilter.length > 0 ? vendedorFilter : vendedor)"
                    item-value="idExibicao"
                    :item-text="formatVendedor"
                    label="Vendedores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.vendedor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ vendedorSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um vendedor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroVendedores"
                            v-model="filtroVendedores"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Vendedores"
                            @change="filterVendedoresToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleVendedores"
                      >
                        <v-list-item-action>
                          <v-icon :color="vendedorSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconVendedores }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro segmento(rede) -->
                <v-col
                  v-if="redes"
                  id="selectRedes"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="redeSelect"
                    :items="filterRedes.length > 0 ? filterRedes : (redeFilter.length > 0 ? redeFilter : rede)"
                    item-value="idExibicao"
                    :item-text="formatRede"
                    label="Redes"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.rede }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ redeSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      selecione uma rede
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroRedes"
                            v-model="filtroRedes"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Redes"
                            @change="filterRedesToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleRedes"
                      >
                        <v-list-item-action>
                          <v-icon :color="redeSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconRedes }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro produto -->
                <v-col
                  v-if="produtos"
                  id="selectProdutos"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-if="produtoMultiplo"
                    v-model="produtoSelect"
                    :items="filterProdutos.length > 0 ? filterProdutos : (produtoFilter.length > 0 ? produtoFilter : produto)"
                    item-value="id"
                    :item-text="formatProduto"
                    label="Produtos"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.produto }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ produtoSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um produto
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroProdutos"
                            v-model="filtroProdutos"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Produtos"
                            @change="filterProdutosToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleProdutos"
                      >
                        <v-list-item-action>
                          <v-icon :color="produtoSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconProdutos }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                  <v-select
                    v-else
                    v-model="produtoSelect"
                    :items="filterProdutos.length > 0 ? filterProdutos : (produtoFilter.length > 0 ? produtoFilter : produto)"
                    item-value="id"
                    item-text="produto"
                    label="Produtos"
                    return-object
                  />
                </v-col>
                <!-- Aqui filtro linha produto -->
                <v-col
                  v-if="linhas"
                  id="selectLinhas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="linhaSelect"
                    :items="filterLinhas.length > 0 ? filterLinhas : (linhaFilter.length > 0 ? linhaFilter : linhasProducao)"
                    item-value="id"
                    :item-text="formatLinha"
                    label="Linhas"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.linhaProducao }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ linhaSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma linha
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroProdutos"
                            v-model="filtroLinhas"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Linhas"
                            @change="filterLinhasToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleLinhas"
                      >
                        <v-list-item-action>
                          <v-icon :color="linhaSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconLinhas }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro categoria -->
                <v-col
                  v-if="categorias && categoria.length > 0"
                  id="selectLinhas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="categoriaSelect"
                    :items="filterCategoria.length > 0 ? filterCategoria : (categoriaFilter.length > 0 ? categoriaFilter : categoria)"
                    item-value="idExebicao"
                    :item-text="formatCategoria"
                    label="Categoria"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.categoria }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.categoria }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ categoriaSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma Categoria
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroCategoria"
                            v-model="filtroCategoria"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Categoria"
                            @change="filterCategoriaToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleCategoria"
                      >
                        <v-list-item-action>
                          <v-icon :color="categoriaSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconCategoria }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro promotor -->
                <v-col
                  v-if="promotores && promotor.length > 0"
                  id="selectLinhas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="promotorSelect"
                    :items="filterPromotor.length > 0 ? filterPromotor : (promotorFilter.length > 0 ? promotorFilter : promotor)"
                    item-value="id"
                    :item-text="formatPromotor"
                    label="Promotores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.promotor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.promotor }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ promotorSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione um promotor
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroProdutos"
                            v-model="filtroPromotor"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Promotores"
                            @change="filterPromotorToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleLinhas"
                      >
                        <v-list-item-action>
                          <v-icon :color="promotorSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconPromotor }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro caixas -->
                <v-col
                  v-if="caixas"
                  id="selectLinhas"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="caixaSelect"
                    :items="filterCaixas.length > 0 ? filterCaixas : caixa"
                    item-value="id"
                    item-text="caixa"
                    label="Caixas"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.caixa }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.caixa }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ caixaSelect.length - 2 }} outros)
                      </span>
                    </template>
                    <template v-slot>
                      Selecione uma caixa
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-action>
                          <input
                            id="filtroCaixas"
                            v-model="filtroCaixas"
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Filtrar Caixas"
                            @change="filterCaixasToggle"
                          >
                        </v-list-item-action>
                        <v-divider
                          slot="prepend-item"
                          class="mt-2"
                        /><br>
                      </v-list-item>
                      <v-list-item
                        slot="prepend-item"
                        ripple
                        @click="toggleCaixas"
                      >
                        <v-list-item-action>
                          <v-icon :color="caixaSelect.length > 0 ? 'indigo darken-4' : ''">
                            {{ iconCaixas }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-title id="idSelecTotos">
                          Selecionar todas
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="receitas && receita.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectReceita"
                    :items="receitaFilter.length > 0 ? receitaFilter : receita"
                    item-value="id"
                    :item-text="formatReceita"
                    label="Grupo Receita"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.nome }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.nome }} - {{ item.nomeBd }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectReceita.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <!-- Aqui filtro tipo devolução -->
                <v-col
                  v-if="tipoDevolucao"
                  id="selectTipoDevoluca"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectTipoDevolucao"
                    :items="tiposDevolucaoFilter.length > 0 ? tiposDevolucaoFilter : tiposDevolucao"
                    item-value="id"
                    item-text="tipo"
                    label="Tipos Devoluções"
                    multiple
                    return-object
                  />
                </v-col>
                <!-- Aqui filtro motivo devolução -->
                <v-col
                  v-if="motivoDevolucao"
                  id="selectMotivoDevolucao"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectMotivoDevolucao"
                    :items="motivosDevolucaoFilter.length > 0 ? motivosDevolucaoFilter : motivosDevolucao"
                    item-value="id"
                    item-text="motivo"
                    label="Motivo Devoluções"
                    multiple
                    return-object
                  />
                </v-col>
                <!-- Aqui filtro tipo brinde -->
                <v-col
                  v-if="tipoBrinde"
                  id="selectTipoDevoluca"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectTipoBrinde"
                    :items="tiposBrindeFilter.length > 0 ? tiposBrindeFilter : tiposBrinde"
                    item-value="id"
                    item-text="tipo"
                    label="Tipos Brindes"
                    multiple
                    return-object
                  />
                </v-col>
                <!-- Aqui filtro motivo brinde -->
                <v-col
                  v-if="motivoBrinde"
                  id="selectMotivoDevolucao"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectMotivoBrinde"
                    :items="motivosBrindeFilter.length > 0 ? motivosBrindeFilter : motivosBrinde"
                    item-value="id"
                    item-text="motivo"
                    label="Motivo Brindes"
                    multiple
                    return-object
                  />
                </v-col>
                <!-- FIltro Segmento -->
                <v-col
                  v-if="segmentos && segmento.length > 0"
                  id="selectEmpresa"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="selectSegmento"
                    :items="filterSegmento.length > 0 ? filterSegmento : segmento"
                    item-value="idExibicao"
                    :item-text="formatSegmento"
                    label="Segmento Cliente"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.segmento }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.segmento }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ selectSegmento.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDate()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Consutlar
                  </v-btn>
                </v-col>
              </v-row>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>
<script>
  import eventEmit from './EventoEmit'

  export default {
    name: 'DashboardCoreFiltroDatas',
    emits: ['updateDadosMaisVida', 'updateDadosMaisVida2'],
    components: {
      DashboardCoreSnackbar: () => import('./Snackbar'),
    },
    props: {
      primeiro: {
        type: Boolean,
        default: false,
      },
      ultimo: {
        type: Boolean,
        default: false,
      },
      empresas: {
        type: Boolean,
        default: false,
      },
      empresas1: {
        type: Boolean,
        default: false,
      },
      url: {
        type: String,
        default: '',
      },
      clientes: {
        type: Boolean,
        default: false,
      },
      clientes1: {
        type: Boolean,
        default: false,
      },
      cidades: {
        type: Boolean,
        default: false,
      },
      cidades1: {
        type: Boolean,
        default: false,
      },
      areas: {
        type: Boolean,
        default: false,
      },
      areas1: {
        type: Boolean,
        default: false,
      },
      vendedores: {
        type: Boolean,
        default: false,
      },
      vendedores1: {
        type: Boolean,
        default: false,
      },
      redes: {
        type: Boolean,
        default: false,
      },
      redes1: {
        type: Boolean,
        default: false,
      },
      produtos: {
        type: Boolean,
        default: false,
      },
      produtos1: {
        type: Boolean,
        default: false,
      },
      linhas: {
        type: Boolean,
        default: false,
      },
      linhas1: {
        type: Boolean,
        default: false,
      },
      caixas: {
        type: Boolean,
        default: false,
      },
      caixas1: {
        type: Boolean,
        default: false,
      },
      btn1: {
        type: Boolean,
        default: false,
      },
      btn2: {
        type: Boolean,
        default: false,
      },
      enableDatas: {
        type: Boolean,
        default: false,
      },
      enableDatas1: {
        type: Boolean,
        default: false,
      },
      filtroCompleto: {
        type: Boolean,
        default: false,
      },
      produtoMultiplo: {
        type: Boolean,
        default: true,
      },
      tipoDevolucao: {
        type: Boolean,
        default: false,
      },
      motivoDevolucao: {
        type: Boolean,
        default: false,
      },
      receitas: {
        type: Boolean,
        default: false,
      },
      textoFiltro: {
        type: Boolean,
        default: true,
      },
      segmentos: {
        type: Boolean,
        default: false,
      },
      segmentos1: {
        type: Boolean,
        default: false,
      },
      filtroDatasIguais: {
        type: Boolean,
        default: true,
      },
      supervisores: {
        type: Boolean,
        default: false,
      },
      supervisores1: {
        type: Boolean,
        default: false,
      },
      tipoBrinde: {
        type: Boolean,
        default: false,
      },
      motivoBrinde: {
        type: Boolean,
        default: false,
      },
      categorias: {
        type: Boolean,
        default: false,
      },
      promotores: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      primeiroDia2: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date2: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      select1: [],
      esconder: false,
      permissaoGestaoComercial: '',
      empresa: [],
      cliente: [],
      clienteFilter: [],
      clienteFilter1: [],
      clienteSelect: [],
      clienteSelect1: [],
      filterClientes: [],
      filtroClientes: '',
      filterClientes1: [],
      filtroClientes1: '',
      cidade: [],
      cidadeFilter: [],
      cidadeFilter1: [],
      cidadeSelect: [],
      cidadeSelect1: [],
      filterCidades: [],
      filtroCidades: '',
      filterCidades1: [],
      filtroCidades1: '',
      rede: [],
      redeFilter: [],
      redeFilter1: [],
      redeSelect: [],
      redeSelect1: [],
      filterRedes: [],
      filtroRedes: '',
      filterRedes1: [],
      filtroRedes1: '',
      area: [],
      areaFilter: [],
      areaFilter1: [],
      areaSelect: [],
      areaSelect1: [],
      filterAreas: [],
      filtroAreas: '',
      filterAreas1: [],
      filtroAreas1: '',
      vendedor: [],
      vendedorRelacao: [],
      vendedorFilter: [],
      vendedorFilter1: [],
      vendedorSelect: [],
      vendedorSelect1: [],
      filterVendedores: [],
      filtroVendedores: '',
      filterVendedores1: [],
      filtroVendedores1: '',
      linhasProducao: [],
      linhaFilter: [],
      linhaFilter1: [],
      linhaSelect: [],
      linhaSelect1: [],
      filterLinhas: [],
      filtroLinhas: '',
      filterLinhas1: [],
      filtroLinhas1: '',
      produto: [],
      produtoSimple: '',
      produtoFilter: [],
      produtoFilter1: [],
      produtoSelect: [],
      produtoSelect1: [],
      filterProdutos: [],
      filtroProdutos: '',
      filterProdutos1: [],
      filtroProdutos1: '',
      caixa: [],
      caixaSelect: [],
      caixaSelect1: [],
      filterCaixas: [],
      filtroCaixas: '',
      filterCaixas1: [],
      filtroCaixas1: '',
      tiposDevolucao: [],
      tiposDevolucaoFilter: [],
      selectTipoDevolucao: [],
      motivosDevolucao: [],
      selectMotivoDevolucao: [],
      motivosDevolucaoFilter: [],
      tiposBrinde: [],
      tiposBrindeFilter: [],
      selectTipoBrinde: [],
      motivosBrinde: [],
      selectMotivoBrinde: [],
      motivosBrindeFilter: [],
      receitaFilter: [],
      receita: [],
      selectReceita: [],
      segmento: [],
      selectSegmento: [],
      selectSegmento1: [],
      filterSegmento: [],
      filterSegmento1: [],
      supervisor: [],
      supervisorFilter: [],
      supervisorFilter1: [],
      supervisorSelect: [],
      supervisorSelect1: [],
      filterSupervisor: [],
      filtroSupervisor: '',
      filterSupervisor1: [],
      filtroSupervisor1: '',
      categoria: [],
      categoriaSelect: [],
      filterCategoria: [],
      categoriaFilter: [],
      filtroCategoria: '',
      promotor: [],
      promotorSelect: [],
      filterPromotor: [],
      promotorFilter: [],
      filtroPromotor: '',
      icone: 'mdi-chevron-down',
      textFiltro: 'Exibir Filtro',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      enableFiltros: false,
      drawer: false,
      exibirChips: false,
      filtrosCarregados: localStorage.filtrosCarregados !== 'false',
    }),

    computed: {
      filtros () {
        this.montarDadosFiltros(this.$store.state.filtros)

        return this.$store.state.filtros
      },

      appliedFilters () {
        const chips = []
        var i = 0
        // Datas
        if (this.primeiroDia) {
          chips.push({
            key: 'dataInicio',
            label: `Início: ${this.formatDatePrimeiroDia(this.primeiroDia)}`,
          })
        }

        if (this.date) {
          chips.push({
            key: 'dataFim',
            label: `Fim: ${this.formatDatePrimeiroDia(this.date)}`,
          })
        }

        if (this.select?.length) {
          const empresaAux = []

          for (i in this.select) {
            empresaAux.push(this.select[i].nomeExibicao)
          }

          chips.push({
            key: 'empresas',
            label: `Empresa(s) (${this.select.length})`,
            value: empresaAux,
          })
        }

        if (this.cidadeSelect?.length) {
          const cidadeAux = []

          for (i in this.cidadeSelect) {
            cidadeAux.push(this.cidadeSelect[i].cidade)
          }

          chips.push({
            key: 'cidade',
            label: `Cidade(s) (${this.cidadeSelect.length})`,
            value: cidadeAux,
          })
        }

        if (this.clienteSelect?.length) {
          const clienteAux = []

          for (i in this.clienteSelect) {
            clienteAux.push(this.clienteSelect[i].cliente + ' - ' + this.clienteSelect[i].nomeBd)
          }

          chips.push({
            key: 'clientes',
            label: `Cliente(s) (${this.clienteSelect.length})`,
            value: clienteAux,
          })
        }

        if (this.areaSelect?.length) {
          const areaAux = []

          for (i in this.areaSelect) {
            areaAux.push(this.areaSelect[i].area + ' - ' + this.areaSelect[i].nomeBd)
          }

          chips.push({
            key: 'areas',
            label: `Área(s) (${this.areaSelect.length})`,
            value: areaAux,
          })
        }

        if (this.supervisorSelect?.length) {
          const supervisorAux = []

          for (i in this.supervisorSelect) {
            supervisorAux.push(this.supervisorSelect[i].supervisor + ' - ' + this.supervisorSelect[i].nomeBd)
          }

          chips.push({
            key: 'supervisores',
            label: `Supervisor(es) (${this.supervisorSelect.length})`,
            value: supervisorAux,
          })
        }

        if (this.vendedorSelect?.length) {
          const vendedorAux = []

          for (i in this.vendedorSelect) {
            vendedorAux.push(this.vendedorSelect[i].vendedor + ' - ' + this.vendedorSelect[i].nomeBd)
          }

          chips.push({
            key: 'vendedores',
            label: `Vendedor(es) (${this.vendedorSelect.length})`,
            value: vendedorAux,
          })
        }

        if (this.redeSelect?.length) {
          const redeAux = []

          for (i in this.redeSelect) {
            redeAux.push(this.redeSelect[i].rede + ' - ' + this.redeSelect[i].nomeBd)
          }

          chips.push({
            key: 'redes',
            label: `Rede(s) (${this.redeSelect.length})`,
            value: redeAux,
          })
        }

        if (this.produtoSelect?.length) {
          const produtoAux = []

          for (i in this.produtoSelect) {
            produtoAux.push(this.produtoSelect[i].produto + ' - ' + this.produtoSelect[i].nomeBd)
          }

          chips.push({
            key: 'produtos',
            label: `Produto(s) (${this.produtoSelect.length})`,
            value: produtoAux,
          })
        }

        if (this.linhaSelect?.length) {
          const linhaAux = []

          for (i in this.linhaSelect) {
            linhaAux.push(this.linhaSelect[i].linhaProducao + ' - ' + this.linhaSelect[i].nomeBd)
          }

          chips.push({
            key: 'linhaProducao',
            label: `Linha(s) Produção(ões) (${this.linhaSelect.length})`,
            value: linhaAux,
          })
        }

        if (this.caixaSelect?.length) {
          const caixaAux = []

          for (i in this.caixaSelect) {
            caixaAux.push(this.caixaSelect[i].caixa)
          }

          chips.push({
            key: 'caixa',
            label: `Caixa(s) (${this.caixaSelect.length})`,
            value: caixaAux,
          })
        }

        if (this.selectSegmento?.length) {
          const segmentoAux = []

          for (i in this.selectSegmento) {
            segmentoAux.push(this.selectSegmento[i].segmento + ' - ' + this.selectSegmento[i].nomeBd)
          }

          chips.push({
            key: 'segmento',
            label: `Segmento(s) (${this.selectSegmento.length})`,
            value: segmentoAux,
          })
        }

        if (this.selectTipoDevolucao?.length) {
          const tipoDevolucaoAux = []

          for (i in this.selectTipoDevolucao) {
            tipoDevolucaoAux.push(this.selectTipoDevolucao[i].tipo)
          }

          chips.push({
            key: 'tipoDevolucao',
            label: `Tipo Devolução(ões) (${this.selectTipoDevolucao.length})`,
            value: tipoDevolucaoAux,
          })
        }

        if (this.selectMotivoDevolucao?.length) {
          const motivoDevolucaoAux = []

          for (i in this.selectMotivoDevolucao) {
            motivoDevolucaoAux.push(this.selectMotivoDevolucao[i].motivo)
          }

          chips.push({
            key: 'motivoDevolucao',
            label: `Motivo Devolução(ões) (${this.selectMotivoDevolucao.length})`,
            value: motivoDevolucaoAux,
          })
        }
        /* aqui filtro 2 */
        // Datas
        if (this.primeiroDia2 && this.filtroCompleto) {
          chips.push({
            key: 'dataInicio2',
            label: `Início 2: ${this.formatDatePrimeiroDia(this.primeiroDia2)}`,
          })
        }

        if (this.date2 && this.filtroCompleto) {
          chips.push({
            key: 'dataFim2',
            label: `Fim 2: ${this.formatDatePrimeiroDia(this.date2)}`,
          })
        }

        if (this.select1?.length && this.filtroCompleto) {
          const empresaAux2 = []

          for (i in this.select1) {
            empresaAux2.push(this.select1[i].nomeExibicao)
          }

          chips.push({
            key: 'empresas2',
            label: `Empresa(s) 2: (${this.select1.length})`,
            value: empresaAux2,
          })
        }

        if (this.cidadeSelect1?.length && this.filtroCompleto) {
          const cidadeAux2 = []

          for (i in this.cidadeSelect1) {
            cidadeAux2.push(this.cidadeSelect1[i].cidade)
          }

          chips.push({
            key: 'cidade2',
            label: `Cidade(s) 2: (${this.cidadeSelect1.length})`,
            value: cidadeAux2,
          })
        }

        if (this.clienteSelect1?.length && this.filtroCompleto) {
          const clienteAux2 = []

          for (i in this.clienteSelect1) {
            clienteAux2.push(this.clienteSelect1[i].cliente + ' - ' + this.clienteSelect1[i].nomeBd)
          }

          chips.push({
            key: 'clientes2',
            label: `Cliente(s) 2: (${this.clienteSelect1.length})`,
            value: clienteAux2,
          })
        }

        if (this.areaSelect1?.length && this.filtroCompleto) {
          const areaAux2 = []

          for (i in this.areaSelect1) {
            areaAux2.push(this.areaSelect1[i].area + ' - ' + this.areaSelect1[i].nomeBd)
          }

          chips.push({
            key: 'areas2',
            label: `Área(s) 2: (${this.areaSelect1.length})`,
            value: areaAux2,
          })
        }

        if (this.supervisorSelect1?.length && this.filtroCompleto) {
          const supervisorAux2 = []

          for (i in this.supervisorSelect1) {
            supervisorAux2.push(this.supervisorSelect1[i].supervisor + ' - ' + this.supervisorSelect1[i].nomeBd)
          }

          chips.push({
            key: 'supervisores2',
            label: `Supervisor(es) 2: (${this.supervisorSelect1.length})`,
            value: supervisorAux2,
          })
        }

        if (this.vendedorSelect1?.length && this.filtroCompleto) {
          const vendedorAux2 = []

          for (i in this.vendedorSelect1) {
            vendedorAux2.push(this.vendedorSelect1[i].vendedor + ' - ' + this.vendedorSelect1[i].nomeBd)
          }

          chips.push({
            key: 'vendedores2',
            label: `Vendedor(es) 2: (${this.vendedorSelect1.length})`,
            value: vendedorAux2,
          })
        }

        if (this.redeSelect1?.length && this.filtroCompleto) {
          const redeAux2 = []

          for (i in this.redeSelect1) {
            redeAux2.push(this.redeSelect1[i].rede + ' - ' + this.redeSelect1[i].nomeBd)
          }

          chips.push({
            key: 'redes2',
            label: `Rede(s) 2: (${this.redeSelect1.length})`,
            value: redeAux2,
          })
        }

        if (this.produtoSelect1?.length && this.filtroCompleto) {
          const produtoAux2 = []

          for (i in this.produtoSelect1) {
            produtoAux2.push(this.produtoSelect1[i].produto + ' - ' + this.produtoSelect1[i].nomeBd)
          }

          chips.push({
            key: 'produtos2',
            label: `Produto(s) 2: (${this.produtoSelect1.length})`,
            value: produtoAux2,
          })
        }

        if (this.linhaSelect1?.length && this.filtroCompleto) {
          const linhaAux2 = []

          for (i in this.linhaSelect1) {
            linhaAux2.push(this.linhaSelect1[i].linhaProducao + ' - ' + this.linhaSelect1[i].nomeBd)
          }

          chips.push({
            key: 'linhaProducao2',
            label: `Linha(s) Produção(ões) 2: (${this.linhaSelect1.length})`,
            value: linhaAux2,
          })
        }

        if (this.caixaSelect1?.length && this.filtroCompleto) {
          const caixaAux2 = []

          for (i in this.caixaSelect1) {
            caixaAux2.push(this.caixaSelect1[i].caixa)
          }

          chips.push({
            key: 'caixa2',
            label: `Caixa(s) 2: (${this.caixaSelect1.length})`,
            value: caixaAux2,
          })
        }

        if (this.selectSegmento1?.length && this.filtroCompleto) {
          const segmentoAux2 = []

          for (i in this.selectSegmento1) {
            segmentoAux2.push(this.selectSegmento1[i].segmento + ' - ' + this.selectSegmento1[i].nomeBd)
          }

          chips.push({
            key: 'segmento2',
            label: `Segmento(s) 2: (${this.selectSegmento1.length})`,
            value: segmentoAux2,
          })
        }

        return chips
      },

      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedDateFormatted1 () {
        return this.formatDate2(this.date2)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },

      computedPrimeiroDia2 () {
        return this.formatDatePrimeiroDia1(this.primeiroDia2)
      },

      /* aqui filtros */
      likesAllClientes () {
        const baseClientes =
          this.filterClientes.length > 0
            ? this.filterClientes
            : this.clienteFilter.length > 0
              ? this.clienteFilter
              : this.cliente

        return this.clienteSelect === baseClientes.length
      },

      likesSomeClientes () {
        return this.clienteSelect.length > 0 && !this.likesAllClientes
      },

      iconClientes () {
        if (this.likesAllClientes) return 'mdi-close-box'
        if (this.likesSomeClientes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllClientes1 () {
        const baseClientes =
          this.filterClientes1.length > 0
            ? this.filterClientes1
            : this.clienteFilter1.length > 0
              ? this.clienteFilter1
              : this.cliente

        return this.clienteSelect === baseClientes.length
      },

      likesSomeClientes1 () {
        return this.clienteSelect1.length > 0 && !this.likesAllClientes1
      },

      iconClientes1 () {
        if (this.likesAllClientes1) return 'mdi-close-box'
        if (this.likesSomeClientes1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCidades () {
        const baseCidade =
          this.filterCidades.length > 0
            ? this.filterCidades
            : this.cidade

        // return this.cidadeSelect.length === this.cidade.length
        return this.cidadeSelect.length === baseCidade.length
      },

      likesSomeCidade () {
        return this.cidadeSelect.length > 0 && !this.likesAllCidades
      },

      iconCidades () {
        if (this.likesAllCidades) return 'mdi-close-box'
        if (this.likesSomeCidade) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCidades1 () {
        const baseCidade =
          this.filterCidades1.length > 0
            ? this.filterCidades1
            : this.cidade

        // return this.cidadeSelect1.length === this.cidade.length
        return this.cidadeSelect1.length === baseCidade.length
      },

      likesSomeCidade1 () {
        return this.cidadeSelect1.length > 0 && !this.likesAllCidades1
      },

      iconCidades1 () {
        if (this.likesAllCidades1) return 'mdi-close-box'
        if (this.likesSomeCidade1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllRedes () {
        const baseRedes =
          this.filterRedes.length > 0
            ? this.filterRedes
            : this.redeFilter.length > 0
              ? this.redeFilter
              : this.rede

        return this.redeSelect.length === baseRedes.length
      },

      likesSomeRedes () {
        return this.redeSelect.length > 0 && !this.likesAllRedes
      },

      iconRedes () {
        if (this.likesAllRedes) return 'mdi-close-box'
        if (this.likesSomeRedes) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllRedes1 () {
        const baseRedes =
          this.filterRedes1.length > 0
            ? this.filterRedes1
            : this.redeFilter1.length > 0
              ? this.redeFilter1
              : this.rede

        return this.redeSelect1.length === baseRedes.length
      },

      likesSomeRedes1 () {
        return this.redeSelect1.length > 0 && !this.likesAllRedes1
      },

      iconRedes1 () {
        if (this.likesAllRedes1) return 'mdi-close-box'
        if (this.likesSomeRedes1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas () {
        const baseAreas =
          this.filterAreas.length > 0
            ? this.filterAreas
            : this.areaFilter.length > 0
              ? this.areaFilter
              : this.area

        return this.areaSelect.length === baseAreas.length
      },

      likesSomeAreas () {
        return this.areaSelect.length > 0 && !this.likesAllAreas
      },

      iconAreas () {
        if (this.likesAllAreas) return 'mdi-close-box'
        if (this.likesSomeAreas) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllAreas1 () {
        const baseAreas =
          this.filterAreas1.length > 0
            ? this.filterAreas1
            : this.areaFilter1.length > 0
              ? this.areaFilter1
              : this.area

        return this.areaSelect1.length === baseAreas.length
      },

      likesSomeAreas1 () {
        return this.areaSelect1.length > 0 && !this.likesAllAreas1
      },

      iconAreas1 () {
        if (this.likesAllAreas1) return 'mdi-close-box'
        if (this.likesSomeAreas1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllVendedores () {
        const baseVendedores =
          this.filterVendedores.length > 0
            ? this.filterVendedores
            : this.vendedorFilter.length > 0
              ? this.vendedorFilter
              : this.vendedor

        return this.vendedorSelect.length === baseVendedores.length
      },

      likesSomeVendedores () {
        return this.vendedorSelect.length > 0 && !this.likesAllVendedores
      },

      iconVendedores () {
        if (this.likesAllVendedores) return 'mdi-close-box'
        if (this.likesSomeVendedores) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllVendedores1 () {
        const baseVendedores =
          this.filterVendedores1.length > 0
            ? this.filterVendedores1
            : this.vendedorFilter1.length > 0
              ? this.vendedorFilter1
              : this.vendedor

        return this.vendedorSelect1.length === baseVendedores.length
      },

      likesSomeVendedores1 () {
        return this.vendedorSelect1.length > 0 && !this.likesAllVendedores1
      },

      iconVendedores1 () {
        if (this.likesAllVendedores1) return 'mdi-close-box'
        if (this.likesSomeVendedores1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllProdutos () {
        const baseProduto =
          this.filterProdutos.length > 0
            ? this.filterProdutos
            : this.produtoFilter.length > 0
              ? this.produtoFilter
              : this.produto

        return this.produtoSelect.length === baseProduto.length
      },

      likesSomeProdutos () {
        return this.produtoSelect.length > 0 && !this.likesAllProdutos
      },

      iconProdutos () {
        if (this.likesAllProdutos) return 'mdi-close-box'
        if (this.likesSomeProdutos) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllProdutos1 () {
        const baseProduto =
          this.filterProdutos1.length > 0
            ? this.filterProdutos1
            : this.produtoFilter1.length > 0
              ? this.produtoFilter1
              : this.produto

        return this.produtoSelect1.length === baseProduto.length
      },

      likesSomeProdutos1 () {
        return this.produtoSelect1.length > 0 && !this.likesAllProdutos1
      },

      iconProdutos1 () {
        if (this.likesAllProdutos1) return 'mdi-close-box'
        if (this.likesSomeProdutos1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllLinhas () {
        const baseLinha =
          this.filterLinhas.length > 0
            ? this.filterLinhas
            : this.linhaFilter.length > 0
              ? this.linhaFilter
              : this.linhasProducao

        return this.linhaSelect.length === baseLinha.length
      },

      likesSomeLinhas () {
        return this.linhaSelect.length > 0 && !this.likesAllLinhas
      },

      iconLinhas () {
        if (this.likesAllLinhas) return 'mdi-close-box'
        if (this.likesSomeLinhas) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllLinhas1 () {
        const baseLinha =
          this.filterLinhas1.length > 0
            ? this.filterLinhas1
            : this.linhaFilter1.length > 0
              ? this.linhaFilter1
              : this.linhasProducao

        return this.linhaSelect1.length === baseLinha.length
      },

      likesSomeLinhas1 () {
        return this.linhaSelect1.length > 0 && !this.likesAllLinhas1
      },

      iconLinhas1 () {
        if (this.likesAllLinhas1) return 'mdi-close-box'
        if (this.likesSomeLinhas1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCaixas () {
        return this.caixaSelect.length === this.caixa.length
      },

      likesSomeCaixas () {
        return this.caixaSelect.length > 0 && !this.likesAllCaixas
      },

      iconCaixas () {
        if (this.likesAllCaixas) return 'mdi-close-box'
        if (this.likesSomeCaixas) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCaixas1 () {
        return this.caixaSelect1.length === this.caixa.length
      },

      likesSomeCaixas1 () {
        return this.caixaSelect1.length > 0 && !this.likesAllCaixas1
      },

      iconCaixas1 () {
        if (this.likesAllCaixas1) return 'mdi-close-box'
        if (this.likesSomeCaixas1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllSupervisores () {
        const baseSupervisor =
          this.filterSupervisor.length > 0
            ? this.filterSupervisor
            : this.supervisorFilter.length > 0
              ? this.supervisorFilter
              : this.supervisor

        return this.supervisorSelect.length === baseSupervisor.length
      },

      likesSomeSupervisores () {
        return this.supervisorSelect.length > 0 && !this.likesAllSupervisores
      },

      iconSupervisores () {
        if (this.likesAllSupervisores) return 'mdi-close-box'
        if (this.likesSomeSupervisores) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllSupervisores1 () {
        const baseSupervisor =
          this.filterSupervisor1.length > 0
            ? this.filterSupervisor1
            : this.supervisorFilter1.length > 0
              ? this.supervisorFilter1
              : this.supervisor

        return this.supervisorSelect1.length === baseSupervisor.length
      },

      likesSomeSupervisores1 () {
        return this.supervisorSelect1.length > 0 && !this.likesAllSupervisores1
      },

      iconSupervisores1 () {
        if (this.likesAllSupervisores1) return 'mdi-close-box'
        if (this.likesSomeSupervisores1) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllCategoria () {
        const baseCategoria =
          this.filterCategoria.length > 0
            ? this.filterCategoria
            : this.categoriaFilter.length > 0
              ? this.categoriaFilter
              : this.categoria

        return this.categoriaSelect.length === baseCategoria.length
      },

      likesSomeCategoria () {
        return this.categoriaSelect.length > 0 && !this.likesAllCategoria
      },

      iconCategoria () {
        if (this.likesAllCategoria) return 'mdi-close-box'
        if (this.likesSomeCategoria) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },

      likesAllPromotor () {
        const basePromotor =
          this.filterPromotor.length > 0
            ? this.filterPromotor
            : this.promotorFilter.length > 0
              ? this.promotorFilter
              : this.promotor

        return this.promotorSelect.length === basePromotor.length
      },

      likesSomePromotor () {
        return this.promotorSelect.length > 0 && !this.likesAllPromotor
      },

      iconPromotor () {
        if (this.likesAllPromotor) return 'mdi-close-box'
        if (this.likesSomePromotor) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
      /* aqui filtros */
    },

    watch: {
      'filtros.empresas': {
        immediate: true,
        handler (empresa) {
          if (empresa && empresa.length === 1) {
            this.select = [...empresa]
          }
        },
      },

      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },

      date2 (val) {
        this.dateFormatted1 = this.formatDate2(this.date2)
      },

      primeiro: function (val) {
        this.primeiro = val
      },

      ultimo: function (val) {
        this.ultimo = val
      },

      empresas: function (val) {
        this.empresas = val
      },

      empresas1: function (val) {
        this.empresas1 = val
      },

      url: function (val) {
        this.url = val
      },

      clientes: function (val) {
        this.clientes = val
      },

      clientes1: function (val) {
        this.clientes1 = val
      },

      cidades: function (val) {
        this.cidades = val
      },

      cidades1: function (val) {
        this.cidades1 = val
      },

      areas: function (val) {
        this.areas = val
      },

      areas1: function (val) {
        this.areas1 = val
      },

      vendedores: function (val) {
        this.vendedores = val
      },

      vendedores1: function (val) {
        this.vendedores1 = val
      },

      redes: function (val) {
        this.redes = val
      },

      redes1: function (val) {
        this.redes1 = val
      },

      produtos: function (val) {
        this.produtos = val
      },

      produtos1: function (val) {
        this.produtos1 = val
      },

      linhas: function (val) {
        this.linhas = val
      },

      linhas1: function (val) {
        this.linhas1 = val
      },

      btn1: function (val) {
        this.btn1 = val
      },

      btn2: function (val) {
        this.btn2 = val
      },

      caixas: function (val) {
        this.caixas = val
      },

      caixas1: function (val) {
        this.caixas1 = val
      },

      enableDatas: function (val) {
        this.enableDatas = val
      },

      textoFiltro: function (val) {
        this.textoFiltro = val
      },

      enableDatas1: function (val) {
        this.enableDatas1 = val
      },

      filtroCompleto: function (val) {
        this.filtroCompleto = val
      },

      produtoMultiplo: function (val) {
        this.produtoMultiplo = val
      },

      tipoDevolucao: function (val) {
        this.tipoDevolucao = val
      },

      motivoDevolucao: function (val) {
        this.motivoDevolucao = val
      },

      receitas: function (val) {
        this.receitas = val
      },

      segmentos: function (val) {
        this.segmentos = val
      },

      segmentos1: function (val) {
        this.segmentos1 = val
      },

      filtroDatasIguais: function (val) {
        this.filtroDatasIguais = val
      },

      supervisores: function (val) {
        this.supervisores = val
      },

      supervisores1: function (val) {
        this.supervisores1 = val
      },

      tipoBrinde: function (val) {
        this.tipoBrinde = val
      },

      motivoBrinde: function (val) {
        this.motivoBrinde = val
      },

      categoria: function (val) {
        this.categoria = val
      },

      promotor: function (val) {
        this.promotor = val
      },
    },

    mounted () {
      if (localStorage.updateDadosFiltros) {
        this.primeiroDia = localStorage.getItem('dataInicial')
        this.date = localStorage.getItem('dataFinal')
      }

      this.$store.dispatch('carregarFiltros')

      this.exibirChips = true
    },

    methods: {
      definirHoje (item) {
        const hoje = new Date()

        if (item === 'primeiroDia') {
          this.primeiroDia = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataFinal') {
          this.date = hoje.toISOString().substr(0, 10)
        } else if (item === 'primeiroDia2') {
          this.primeiroDia2 = hoje.toISOString().substr(0, 10)
        } else if (item === 'dataFinal2') {
          this.date2 = hoje.toISOString().substr(0, 10)
        }
      },

      montarDadosFiltros (dados) {
        this.empresa = dados.empresa

        if (this.empresa.length === 1) {
          this.select = this.empresa
          this.select1 = this.empresa
        }

        this.cidade = dados.cidade
        this.cliente = dados.clientes
        this.area = dados.area
        this.supervisor = dados.supervisor
        this.vendedor = dados.vendedor
        this.rede = dados.rede
        this.produto = dados.produto
        this.linhasProducao = dados.linhasProducao
        this.caixa = dados.caixa
        this.segmento = dados.segmento
        this.categoria = dados.categoria
        this.promotor = dados.promotor
        this.receita = dados.receita
        this.tiposDevolucao = dados.tiposDevolucao
        this.motivosDevolucao = dados.motivosDevolucao
        this.tiposBrinde = dados.tiposBrinde
        this.motivosBrinde = dados.motivosBrinde
      },

      toggleDrawer () {
        this.drawer = !this.drawer
      },

      removeFilter (key) {
        switch (key) {
          case 'empresas':
            this.select = []
            break
          case 'cidade':
            this.cidadeSelect = []
            break
          case 'clientes':
            this.clienteSelect = []
            break
          case 'areas':
            this.areaSelect = []
            break
          case 'supervisores':
            this.supervisorSelect = []
            break
          case 'vendedores':
            this.vendedorSelect = []
            break
          case 'redes':
            this.redeSelect = []
            break
          case 'produtos':
            this.produtoSelect = []
            break
          case 'linhaProducao':
            this.linhaSelect = []
            break
          case 'caixa':
            this.caixaSelect = []
            break
          case 'segmento':
            this.selectSegmento = []
            break
          case 'tipoDevolucao':
            this.selectTipoDevolucao = []
            break
          case 'motivoDevolucao':
            this.selectMotivoDevolucao = []
            break
          case 'dataInicio':
            break
          case 'dataFim':
            break
          case 'empresas2':
            this.select1 = []
            break
          case 'cidade2':
            this.cidadeSelect1 = []
            break
          case 'clientes2':
            this.clienteSelect1 = []
            break
          case 'areas2':
            this.areaSelect1 = []
            break
          case 'supervisores2':
            this.supervisorSelect1 = []
            break
          case 'vendedores2':
            this.vendedorSelect1 = []
            break
          case 'redes2':
            this.redeSelect1 = []
            break
          case 'produtos2':
            this.produtoSelect1 = []
            break
          case 'linhaProducao2':
            this.linhaSelect1 = []
            break
          case 'caixa2':
            this.caixaSelect1 = []
            break
          case 'segmento2':
            this.selectSegmento1 = []
            break
          case 'dataInicio2':
            break
          case 'dataFim2':
            break
        }
      },

      getTooltipValue (chip) {
        if (Array.isArray(chip.value)) {
          return chip.value.join(', ')
        }

        return chip.label
      },

      formatCliente (item) {
        return `${item.cliente} - ${item.nomeBd}`
      },

      formatArea (item) {
        return `${item.area} - ${item.nomeBd}`
      },

      formatSupervisor (item) {
        return `${item.supervisor} - ${item.nomeBd}`
      },

      formatVendedor (item) {
        return `${item.vendedor} - ${item.nomeBd}`
      },

      formatRede (item) {
        return `${item.rede} - ${item.nomeBd}`
      },

      formatProduto (item) {
        return `${item.produto} - ${item.nomeBd}`
      },

      formatLinha (item) {
        return `${item.linhaProducao} - ${item.nomeBd}`
      },

      formatSegmento (item) {
        return `${item.segmento} - ${item.nomeBd}`
      },

      formatCategoria (item) {
        return `${item.categoria} - ${item.nomeBd}`
      },

      formatPromotor (item) {
        return `${item.promotor} - ${item.nomeBd}`
      },

      formatReceita (item) {
        return `${item.nome} - ${item.nomeBd}`
      },

      toggleClientes () {
        this.$nextTick(() => {
          if (this.likesAllClientes) {
            this.clienteSelect = []
          } else {
            const baseCliente =
              this.filterClientes.length > 0
                ? this.filterClientes
                : this.clienteFilter > 0
                  ? this.clienteFilter
                  : this.cliente

            this.clienteSelect = [...baseCliente]
          }
        })
      },

      filterClientesToggle () {
        this.filterClientes = []

        if (this.filtroClientes.length > 0) {
          const baseCliente = this.clienteFilter.length > 0 ? this.clienteFilter : this.cliente

          this.filterClientes = baseCliente.filter(cliente => cliente.cliente.toLowerCase().includes(this.filtroClientes.toLowerCase()))
        }
      },

      toggleClientes1 () {
        this.$nextTick(() => {
          if (this.likesAllClientes1) {
            this.clienteSelect1 = []
          } else {
            const baseCliente =
              this.filterClientes1.length > 0
                ? this.filterClientes1
                : this.clienteFilter1 > 0
                  ? this.clienteFilter1
                  : this.cliente

            this.clienteSelect1 = [...baseCliente]
          }
        })
      },

      filterClientesToggle1 () {
        this.filterClientes = []

        if (this.filtroClientes1.length > 0) {
          const baseCliente = this.clienteFilter1.length > 0 ? this.clienteFilter1 : this.cliente

          this.filterClientes = baseCliente.filter(cliente => cliente.cliente.toLowerCase().includes(this.filtroClientes1.toLowerCase()))
        }
      },

      toggleCidades () {
        this.$nextTick(() => {
          if (this.likesAllCidades) {
            this.cidadeSelect = []
          } else {
            const baseCidade =
              this.filterCidades.length > 0
                ? this.filterCidades
                : this.cidade

            this.cidadeSelect = [...baseCidade]
          }
        })
      },

      filterCidadesToggle () {
        if (this.filtroCidades.length > 0) {
          if (this.cidadeFilter.length > 0) {
            for (let i = 0; i < this.cidadeFilter.length; i++) {
              if (this.cidadeFilter[i].cidade.toLowerCase().includes(this.filtroCidades.toLowerCase())) {
                this.filterCidades.push(this.cidadeFilter[i])
              }
            }
          } else {
            for (let i = 0; i < this.cidade.length; i++) {
              if (this.cidade[i].cidade.toLowerCase().includes(this.filtroCidades.toLowerCase())) {
                this.filterCidades.push(this.cidade[i])
              }
            }
          }
        } else {
          this.filterCidades = []
        }
      },

      toggleCidades1 () {
        this.$nextTick(() => {
          if (this.likesAllCidades1) {
            this.cidadeSelect1 = []
          } else {
            if (this.filterCidades1.length > 0) {
              this.cidadeSelect1 = this.filterCidades1
            } else if (this.cidadeFilter1.length > 0) {
              this.cidadeSelect1 = this.cidadeFilter1.slice()
            } else {
              this.cidadeSelect1 = this.cidade.slice()
            }
          }
        })
      },

      filterCidadesToggle1 () {
        if (this.filtroCidades1.length > 0) {
          if (this.cidadeFilter1.length > 0) {
            for (let i = 0; i < this.cidadeFilter1.length; i++) {
              if (this.cidadeFilter1[i].cidade.toLowerCase().includes(this.filtroCidades1.toLowerCase())) {
                this.filterCidades1.push(this.cidadeFilter1[i])
              }
            }
          } else {
            for (let i = 0; i < this.cidade.length; i++) {
              if (this.cidade[i].cidade.toLowerCase().includes(this.filtroCidades1.toLowerCase())) {
                this.filterCidades1.push(this.cidade[i])
              }
            }
          }
        } else {
          this.filterCidades1 = []
        }
      },

      toggleRedes () {
        this.$nextTick(() => {
          if (this.likesAllRedes) {
            this.redeSelect = []
          } else {
            const baseRedes =
              this.filterRedes.length > 0
                ? this.filterRedes
                : this.redeFilter.length > 0
                  ? this.redeFilter
                  : this.rede

            this.redeSelect = [...baseRedes]
          }
        })
      },

      filterRedesToggle () {
        this.filterRedes = []

        if (this.filtroRedes.length > 0) {
          const baseRedes = this.redeFilter.length > 0 ? this.redeFilter : this.rede

          this.filterRedes = baseRedes.filter(rede => rede.rede.toLowerCase().includes(this.filtroRedes.toLowerCase()))
        }
      },

      toggleRedes1 () {
        this.$nextTick(() => {
          if (this.likesAllRedes1) {
            this.redeSelect1 = []
          } else {
            const baseRedes =
              this.filterRedes1.length > 0
                ? this.filterRedes1
                : this.redeFilter1.length > 0
                  ? this.redeFilter1
                  : this.rede

            this.redeSelect1 = [...baseRedes]
          }
        })
      },

      filterRedesToggle1 () {
        this.filterRedes1 = []

        if (this.filtroRedes1.length > 0) {
          const baseRedes = this.redeFilter1.length > 0 ? this.redeFilter1 : this.rede

          this.filterRedes1 = baseRedes.filter(rede => rede.rede.toLowerCase().includes(this.filtroRedes1.toLowerCase()))
        }
      },

      toggleAreas () {
        this.$nextTick(() => {
          if (this.likesAllAreas) {
            this.areaSelect = []
          } else {
            const baseAreas =
              this.filterAreas.length > 0
                ? this.filterAreas
                : this.areaFilter.length > 0
                  ? this.areaFilter
                  : this.area

            this.areaSelect = [...baseAreas]
          }
        })
      },

      filterAreasToggle () {
        this.filterAreas = []

        if (this.filtroAreas.length > 0) {
          const baseAreas = this.areaFilter.length > 0 ? this.areaFilter : this.area

          this.filterAreas = baseAreas.filter(area => area.area.toLowerCase().includes(this.filtroAreas.toLowerCase()))
        }
      },

      toggleAreas1 () {
        this.$nextTick(() => {
          if (this.likesAllAreas1) {
            this.areaSelect1 = []
          } else {
            const baseAreas =
              this.filterAreas1.length > 0
                ? this.filterAreas1
                : this.areaFilter1.length > 0
                  ? this.areaFilter1
                  : this.area

            this.areaSelect1 = [...baseAreas]
          }
        })
      },

      filterAreasToggle1 () {
        this.filterAreas1 = []

        if (this.filtroAreas1.length > 0) {
          const baseAreas = this.areaFilter1.length > 0 ? this.areaFilter1 : this.area

          this.filterAreas1 = baseAreas.filter(area => area.area.toLowerCase().includes(this.filtroAreas1.toLowerCase()))
        }
      },

      toggleVendedores () {
        this.$nextTick(() => {
          if (this.likesAllVendedores) {
            this.vendedorSelect = []
          } else {
            const baseVendedores =
              this.filterVendedores.length > 0
                ? this.filterVendedores
                : this.vendedorFilter.length > 0
                  ? this.vendedorFilter
                  : this.vendedor

            this.vendedorSelect = [...baseVendedores]
          }
        })
      },

      filterVendedoresToggle () {
        this.filterVendedores = []

        if (this.filtroVendedores.length > 0) {
          const baseVendedores = this.vendedorFilter.length > 0 ? this.vendedorFilter : this.vendedor

          this.filterVendedores = baseVendedores.filter(vendedor => vendedor.vendedor.toLowerCase().includes(this.filtroVendedores.toLowerCase()))
        }
      },

      toggleVendedores1 () {
        this.$nextTick(() => {
          if (this.likesAllVendedores1) {
            this.vendedorSelect1 = []
          } else {
            const baseVendedores =
              this.filterVendedores1.length > 0
                ? this.filterVendedores1
                : this.vendedorFilter1.length > 0
                  ? this.vendedorFilter1
                  : this.vendedor

            this.vendedorSelect1 = [...baseVendedores]
          }
        })
      },

      filterVendedoresToggle1 () {
        this.filterVendedores1 = []

        if (this.filtroVendedores1.length > 0) {
          const baseVendedores = this.vendedorFilter1.length > 0 ? this.vendedorFilter1 : this.vendedor

          this.filterVendedores1 = baseVendedores.filter(vendedor => vendedor.vendedor.toLowerCase().includes(this.filtroVendedores1.toLowerCase()))
        }
      },

      toggleProdutos () {
        this.$nextTick(() => {
          if (this.likesAllProdutos) {
            this.produtoSelect = []
          } else {
            const baseProdutos =
              this.filterProdutos.length > 0
                ? this.filterProdutos
                : this.produtoFilter.length > 0
                  ? this.produtoFilter
                  : this.produto

            this.produtoSelect = [...baseProdutos]
          }
        })
      },

      filterProdutosToggle () {
        this.filterProdutos = []

        if (this.filtroProdutos.length > 0) {
          const baseProdutos = this.produtoFilter.length > 0 ? this.produtoFilter : this.produto

          this.filterProdutos = baseProdutos.filter(produto => produto.produto.toLowerCase().includes(this.filtroProdutos.toLowerCase()))
        }
      },

      toggleProdutos1 () {
        this.$nextTick(() => {
          if (this.likesAllProdutos1) {
            this.produtoSelect1 = []
          } else {
            const baseProdutos =
              this.filterProdutos1.length > 0
                ? this.filterProdutos1
                : this.produtoFilter1.length > 0
                  ? this.produtoFilter1
                  : this.produto

            this.produtoSelect1 = [...baseProdutos]
          }
        })
      },

      filterProdutosToggle1 () {
        this.filterProdutos1 = []

        if (this.filtroProdutos1.length > 0) {
          const baseProdutos = this.produtoFilter1.length > 0 ? this.produtoFilter1 : this.produto

          this.filterProdutos1 = baseProdutos.filter(produto => produto.produto.toLowerCase().includes(this.filtroProdutos1.toLowerCase()))
        }
      },

      toggleLinhas () {
        this.$nextTick(() => {
          if (this.likesAllLinhas) {
            this.linhaSelect = []
          } else {
            const baseLinhas =
              this.filterLinhas.length
                ? this.filterLinhas
                : this.linhaFilter.length > 0
                  ? this.linhaFilter
                  : this.linhasProducao

            this.linhaSelect = [...baseLinhas]
          }
        })
      },

      filterLinhasToggle () {
        this.filterLinhas = []

        if (this.filtroLinha.length > 0) {
          const baseLinhas = this.linhaFilter.length > 0 ? this.linhaFilter : this.linhasProducao

          this.filterLinhas = baseLinhas.filter(linha => linha.linha.toLowerCase().includes(this.filtroLinhas.toLowerCase()))
        }
      },

      toggleLinhas1 () {
        this.$nextTick(() => {
          if (this.likesAllLinhas1) {
            this.linhaSelect1 = []
          } else {
            const baseLinhas =
              this.filterLinhas.length
                ? this.filterLinhas
                : this.linhaFilter.length > 0
                  ? this.linhaFilter
                  : this.linhasProducao

            this.linhaSelect = [...baseLinhas]
          }
        })
      },

      filterLinhasToggle1 () {
        this.filterLinhas1 = []

        if (this.filtroLinhas1.length > 0) {
          const baseLinhas = this.linhaFilter1.length > 0 ? this.linhaFilter1 : this.linhasProducao

          this.filterLinhas1 = baseLinhas.filter(linha => linha.linha.toLowerCase().includes(this.filtroLinhas1.toLowerCase()))
        }
      },

      toggleCategoria () {
        this.$nextTick(() => {
          if (this.likesAllCategoria) {
            this.categoriaSelect = []
          } else {
            const baseCategoria =
              this.filterCategoria.length
                ? this.filterCategoria
                : this.categoriaFilter.length > 0
                  ? this.categoriaFilter
                  : this.categoria

            this.categoriaSelect = [...baseCategoria]
          }
        })
      },

      filterCategoriaToggle () {
        this.filterCategoria = []

        if (this.filtroCategoria.length > 0) {
          const baseCategoria = this.categoriaFilter.length > 0 ? this.categoriaFilter : this.categoria

          this.filterCategoria = baseCategoria.filter(categoria => categoria.categoria.toLowerCase().includes(this.filtroCategoria.toLowerCase()))
        }
      },

      togglePromotor () {
        this.$nextTick(() => {
          if (this.likesAllPromotor) {
            this.promotorSelect = []
          } else {
            const basePromotor =
              this.filterPromotor.length
                ? this.filterPromotor
                : this.promotorFilter.length > 0
                  ? this.promotorFilter
                  : this.promotor

            this.promotorSelect = [...basePromotor]
          }
        })
      },

      filterPromotorToggle () {
        this.filterPromotor = []

        if (this.filtroPromotor.length > 0) {
          const basePromotor = this.promotorFilter.length > 0 ? this.promotorFilter : this.promotor

          this.filterPromotor = basePromotor.filter(promotor => promotor.promotor.toLowerCase().includes(this.filtroPromotor.toLowerCase()))
        }
      },

      toggleCaixas () {
        this.$nextTick(() => {
          if (this.likesAllCaixas) {
            this.caixaSelect = []
          } else {
            if (this.filterCaixas.length > 0) {
              this.caixaSelect = this.filterCaixas
            } else {
              this.caixaSelect = this.caixa.slice()
            }
          }
        })
      },

      filterCaixasToggle () {
        if (this.filtroCaixas.length > 0) {
          for (let i = 0; i < this.caixa.length; i++) {
            if (this.caixa[i].caixa.toLowerCase().includes(this.filtroCaixas.toLowerCase())) {
              this.filterCaixas.push(this.caixa[i])
            }
          }
        } else {
          this.filterCaixas = []
        }
      },

      toggleCaixas1 () {
        this.$nextTick(() => {
          if (this.likesAllCaixas1) {
            this.caixaSelect1 = []
          } else {
            if (this.filterCaixas1.length > 0) {
              this.caixaSelect1 = this.filterCaixas1
            } else {
              this.caixaSelect1 = this.caixa.slice()
            }
          }
        })
      },

      filterCaixasToggle1 () {
        if (this.filtroCaixas1.length > 0) {
          for (let i = 0; i < this.caixa.length; i++) {
            if (this.caixa[i].caixa.toLowerCase().includes(this.filtroCaixas1.toLowerCase())) {
              this.filterCaixas1.push(this.caixa[i])
            }
          }
        } else {
          this.filterCaixasas1 = []
        }
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        if (this.filtroDatasIguais) {
          this.formatDate2(date)
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDate2 (date) {
        if (!date) {
          return null
        }

        this.date2 = date

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia1 (date) {
        if (!date) {
          return null
        }

        this.primeiroDia2 = date

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      updateDate () {
        const dadosVendedores1 = this.vendedorSelect && this.vendedorSelect.length > 0 ? this.vendedorSelect : (this.vendedorRelacao.length > 0 ? this.vendedorRelacao : [])
        const dadosVendedores2 = this.vendedorSelect1 && this.vendedorSelect1.length > 0 ? this.vendedorSelect1 : (this.vendedorRelacao.length > 0 ? this.vendedorRelacao : [])

        eventEmit.$emit('update-dados-mais-vida', this.primeiroDia, this.date, this.select, this.cidadeSelect, this.areaSelect, this.redeSelect, dadosVendedores1, this.produtoSelect, this.linhaSelect, this.clienteSelect, this.caixaSelect, this.selectTipoDevolucao, this.selectMotivoDevolucao, this.primeiroDia2, this.date2, this.select1, this.cidadeSelect1, this.areaSelect1, this.redeSelect1, dadosVendedores2, this.produtoSelect1, this.linhaSelect1, this.clienteSelect1, this.caixaSelect1, this.selectReceita, this.selectSegmento, this.selectSegmento1, this.supervisorSelect, this.supervisorSelect1, this.selectTipoBrinde, this.selectMotivoBrinde, this.categoriaSelect, this.promotorSelect)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      filtrarEmpresa () {
        this.clienteFilter = []
        this.redeFilter = []
        this.areaFilter = []
        this.vendedorFilter = []
        this.produtoFilter = []
        this.linhaFilter = []
        this.receitaFilter = []
        this.filterSegmento = []
        this.filterSupervisor = []
        this.filterCategoria = []
        this.filterPromotor = []

        if (this.select && this.select.length > 0) {
          this.select.forEach(empresa => {
            const clienteAux = this.cliente.filter(cl => cl.nomeBd === empresa.nome_bd)

            this.clienteFilter.push(...clienteAux)

            const redesAux = this.rede.filter(r => r.nomeBd === empresa.nome_bd)

            this.redeFilter.push(...redesAux)

            const areasAux = this.area.filter(a => a.nomeBd === empresa.nome_bd)

            this.areaFilter.push(...areasAux)

            const vendedorAux = this.vendedor.filter(vendedor => vendedor.nomeBd === empresa.nome_bd)

            this.vendedorFilter.push(...vendedorAux)

            const produtoAux = this.produto.filter(p => p.nomeBd === empresa.nome_bd)

            this.produtoFilter.push(...produtoAux)

            const linhaAux = this.linhasProducao.filter(l => l.nomeBd === empresa.nome_bd)

            this.linhaFilter.push(...linhaAux)

            const receitaAux = this.receita.filter(rc => rc.nomeBd === empresa.nome_bd)

            this.receitaFilter.push(...receitaAux)

            const segmentoAux = this.segmento.filter(sg => sg.nomeBd === empresa.nome_bd)

            this.filterSegmento.push(...segmentoAux)

            const supervisorAux = this.supervisor.filter(su => su.nomeBd === empresa.nome_bd)

            this.filterSupervisor.push(...supervisorAux)

            const categoriaAux = this.categoria.filter(c => c.nomeBd === empresa.nome_bd)

            this.filterCategoria.push(...categoriaAux)

            const promotorAux = this.promotor.filter(pr => pr.nomeBd === empresa.nome_bd)

            this.filterPromotor.push(...promotorAux)
          })
        }

        this.clienteFilter.sort((a, b) => a.cliente.localeCompare(b.cliente))

        this.redeFilter.sort((a, b) => a.rede.localeCompare(b.rede))

        this.areaFilter.sort((a, b) => a.area.localeCompare(b.area))

        this.vendedorFilter.sort((a, b) => a.vendedor.localeCompare(b.vendedor))

        this.produtoFilter.sort((a, b) => a.produto.localeCompare(b.produto))

        this.linhaFilter.sort((a, b) => a.linha.localeCompare(b.linha))

        this.receitaFilter.sort((a, b) => a.nome.localeCompare(b.nome))

        this.filterSegmento.sort((a, b) => a.segmento.localeCompare(b.segmento))

        this.filterSupervisor.sort((a, b) => a.supervisor.localeCompare(b.supervisor))

        this.filterCategoria.sort((a, b) => a.categoria.localeCompare(b.categoria))

        this.filterPromotor.sort((a, b) => a.promotor.localeCompare(b.promotor))
      },

      filtrarEmpresa1 () {
        this.clienteFilter1 = []
        this.redeFilter1 = []
        this.areaFilter1 = []
        this.vendedorFilter1 = []
        this.produtoFilter1 = []
        this.linhaFilter1 = []
        this.filterSegmento1 = []
        this.filterSupervisor1 = []

        if (this.select1 && this.select1.length > 0) {
          this.select1.forEach(empresa => {
            const clienteAux = this.cliente.filter(cl => cl.nomeBd === empresa.nome_bd)

            this.clienteFilter1.push(...clienteAux)

            const redesAux = this.rede.filter(r => r.nomeBd === empresa.nome_bd)

            this.redeFilter1.push(...redesAux)

            const areasAux = this.area.filter(a => a.nomeBd === empresa.nome_bd)

            this.areaFilter1.push(...areasAux)

            const vendedorAux = this.vendedor.filter(vendedor => vendedor.nomeBd === empresa.nome_bd)

            this.vendedorFilter1.push(...vendedorAux)

            const produtoAux = this.produto.filter(p => p.nomeBd === empresa.nome_bd)

            this.produtoFilter1.push(...produtoAux)

            const linhaAux = this.linha.filter(l => l.nomeBd === empresa.nome_bd)

            this.linhaFilter1.push(...linhaAux)

            const segmentoAux = this.segmento.filter(sg => sg.nomeBd === empresa.nome_bd)

            this.filterSegmento1.push(...segmentoAux)

            const supervisorAux1 = this.supervisor.filter(su => su.nomeBd === empresa.nome_bd)

            this.filterSupervisor1.push(...supervisorAux1)
          })
        }

        this.clienteFilter1.sort((a, b) => a.cliente.localeCompare(b.cliente))

        this.redeFilter1.sort((a, b) => a.rede.localeCompare(b.rede))

        this.areaFilter1.sort((a, b) => a.area.localeCompare(b.area))

        this.vendedorFilter1.sort((a, b) => a.vendedor.localeCompare(b.vendedor))

        this.produtoFilter1.sort((a, b) => a.produto.localeCompare(b.produto))

        this.linhaFilter1.sort((a, b) => a.linha.localeCompare(b.linha))

        this.filterSegmento1.sort((a, b) => a.segmento.localeCompare(b.segmento))

        this.filterSupervisor1.sort((a, b) => a.supervisor.localeCompare(b.supervisor))
      },

      toggleSupervisores () {
        this.$nextTick(() => {
          if (this.likesAllSupervisores) {
            this.supervisorSelect = []
          } else {
            const baseSupervisor =
              this.filterSupervisor.length > 0
                ? this.filterSupervisor
                : this.supervisorFilter.length > 0
                  ? this.supervisorFilter
                  : this.supervisor

            this.supervisorSelect = [...baseSupervisor]
          }
        })
      },

      filterSupervisoresToggle () {
        this.filterSupervisor = []

        if (this.filtroSupervisor.length > 0) {
          const baseSupervisor = this.supervisorFilter.length > 0 ? this.supervisorFilter : this.supervisor

          this.filterSupervisor = baseSupervisor.filter(supervisor => supervisor.supervisor.toLowerCase().includes(this.filtroSupervisor.toLowerCase()))
        }
      },

      toggleSupervisores1 () {
        this.$nextTick(() => {
          if (this.likesAllSupervisores1) {
            this.supervisorSelect1 = []
          } else {
            const baseSupervisor =
              this.filterSupervisor1.length > 0
                ? this.filterSupervisor1
                : this.supervisorFilter1.length > 0
                  ? this.supervisorFilter1
                  : this.supervisor

            this.supervisorSelect1 = [...baseSupervisor]
          }
        })
      },

      filterSupervisoresToggle1 () {
        this.filterSupervisor1 = []

        if (this.filtroSupervisor1.length > 0) {
          const baseSupervisor = this.supervisorFilter1.length > 0 ? this.supervisorFilter1 : this.supervisor

          this.filterSupervisor1 = baseSupervisor.filter(supervisor => supervisor.supervisor.toLowerCase().includes(this.filtroSupervisor1.toLowerCase()))
        }
      },
    },

  }
</script>

<style scoped>
  .btnFiltroFixado {
    position: fixed;
    top: 65px;
    z-index: 9999;
    transition: right .3s ease;
  }

  .drawerFiltros {
    top: 65px !important;
    height: auto !important;
    max-height: calc(100vh - 55px);
    overflow-y: auto;
    box-shadow: -2px 0 12px rgba(0,0,0,0.25);
  }

  .filters-enter-active {
    animation: enter .5s cubic-bezier(.34,1.56,.64,1);
  }

  .filters-leave-active {
    animation: leave .5s ease;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    .filterMobile{
      display: block
    }

    .filterWeb{
      display: none
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #btnRefazer {
      font-size: 10px;
      margin-top: 2rem;
      margin-left: -1.4rem;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .filterMobile{
      display: none
    }

    .filterWeb{
      display: block
    }

    #btnRefazer {
      font-size: 12px;
      display: flex;
      max-width: 15vw;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .cell {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
      max-width: 840px;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1800px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .container {
      max-width: 1500px;
    }
  }
</style>

<style lang="sass">
  .filterMobile
    display: none

  .filterWeb
    display: block

  #btnRefazer
    margin: 1.5rem auto

</style>
